
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop value  标签数据
*/
@Component({
    name: 'keyword-dialog'
})
export default class extends Vue {
    @Prop({ required: true }) readonly value!: any[]
    private dialogVisible = false

    private show() {
        this.dialogVisible = true
    }

    private hide() {
        this.dialogVisible = false
    }
}
